export enum TTSHighlightMode {
  // highlight blocks as they are spoken
  BLOCK = "block",
  // highlight individual words as they are spoken
  WORD = "word",
}

export enum SettingsModalType {
  SPEED = "speed",
  VOICE = "voice",
  SETTINGS = "settings",
}
